/* eslint-disable no-undef */
import axios from 'axios';

import { withCommandErrorCast } from '../../utils/commandErrors';
import { filterBombardment, hash } from '../../utils/filterBombardment';

import type { AxiosResponse } from 'axios';

export type BaseCommand = {
  type: string;
  payload: unknown;
};

type DispatchCommand<Command extends BaseCommand> = {
  command: Command;
  prospectId: string;
  meta?: { [key: string]: string };
};

type DispatchMultipleCommands<Command extends BaseCommand> = {
  prospectId: string;
  commands: Command[];
  meta?: { [key: string]: string };
};

export const createCommandDispatchers = <Command extends BaseCommand>(
  createCommandClient: (prospectId: string) => string,
) => {
  const client = axios.create({
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const dispatchCommand = async ({ command, prospectId }: DispatchCommand<Command>): Promise<AxiosResponse> => {
    const endpoint = createCommandClient(prospectId);
    return filterBombardment(() => hash([command.type, command.payload]))(() =>
      withCommandErrorCast(command.type, async () => (await client.post(endpoint, command)).data),
    );
  };

  const dispatchMultipleCommands = async ({
    commands,
    prospectId,
  }: DispatchMultipleCommands<Command>): Promise<AxiosResponse> => {
    const endpoint = createCommandClient(prospectId);
    const commandsKey = commands.map((command) => command.type).join(', ');
    return filterBombardment(() => hash(commandsKey))(() =>
      withCommandErrorCast(commandsKey, async () => (await client.post(endpoint, commands)).data),
    );
  };

  return { dispatchCommand, dispatchMultipleCommands };
};
